/** Converte a mensagem que as rotas JSON (get-folder, search, cron-update) devolvem no formato da lista. */
export function normalizeMessage(raw, folder) {
    var _a, _b, _c;
    const address = folder === 'INBOX.Sent' ? ((_a = raw.to) === null || _a === void 0 ? void 0 : _a[0]) || ((_b = raw.from) === null || _b === void 0 ? void 0 : _b[0]) : (_c = raw.from) === null || _c === void 0 ? void 0 : _c[0];
    return {
        uid: Number(raw.uid),
        name: address ? address.personal || address.mailbox || 'Remetente desconhecido' : 'Remetente desconhecido',
        email: (address === null || address === void 0 ? void 0 : address.mail) || 'sem-email',
        subject: raw.subject && raw.subject[0] ? String(raw.subject[0]) : null,
        date: raw.formatedDate || '',
        seen: Boolean(raw.seen),
    };
}
/** Lista paginada do Laravel: "data" pode vir como lista ou objeto. */
export function paginatorItems(page) {
    if (!page || !page.data)
        return [];
    return (Array.isArray(page.data) ? page.data : Object.values(page.data)).filter(Boolean);
}
export function initials(name) {
    const parts = (name || '?').trim().split(/\s+/).filter(Boolean);
    if (!parts.length)
        return '?';
    return (parts.length > 1 ? parts[0][0] + parts[1][0] : parts[0][0]).toUpperCase();
}
export function withMessage(template, uid) {
    return template.replace('__MESSAGE__', encodeURIComponent(String(uid)));
}
